import React from "react";
import {
  Datagrid,
  TextField,
  FunctionField,
  ReferenceField,
  ListProps,
  Filter,
  SearchInput,
} from "react-admin";
import CustomDateField from "components/CustomDateField";
import { SchoolIdSelected } from "utils/tools";
import CustomPriceField from "components/CustomPriceField";
import ListWrapper from "../../components/ListWrapper";
import ShowPdfButton from "./components/ShowPdfButton";
import ActionsMenu from "../../components/ActionsMenu";

const CustomerReceiptsList = (props: ListProps) => {
  const CustomerReceiptsFilter = (props: any) => (
    <Filter {...props}>
      <SearchInput source="search" alwaysOn />
    </Filter>
  );

  const translateType = (type: string) => {
    switch (type) {
      case "parent":
        return "Parent";
      case "company_person_in_charge":
        return "Person In Charge";
      default:
        return "-";
    }
  };

  const breadcrumb = [{ link: "/customerReceipts", title: "Receipts" }];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Receipts"
        denseMode
        exporter={false}
        filters={<CustomerReceiptsFilter />}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
        }}
        sort={{ field: "CreatedAt", order: "DESC" }}
        bulkActionButtons={false}
        {...props}
      >
        <Datagrid>
          <ReferenceField
            source="parentId"
            reference="customers"
            label="Customer"
            link={false}
          >
            <FunctionField
              render={(record: any) => (
                <div>
                  {record.firstName} {record.lastName} -{" "}
                  {translateType(record.type)}
                </div>
              )}
            />
          </ReferenceField>

          <CustomDateField source="createdAt" />
          <TextField label="Description" source="description" emptyText="-" />
          <CustomPriceField source="amount" />

          <FunctionField
            label="Action"
            render={(record: any) => {
              return <ActionsMenu render={[<ShowPdfButton data={record} />]} />;
            }}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default CustomerReceiptsList;
